<template>
  <div class="screen-wrapper" :style="screenWrapperStyle">
    <div class="screen" data-model-id="11:2092" :style="screenStyle">
      
      <div>
        <img class="mask-group-3" alt="Mask group" src="/static/img/about-mask-group-1.png" />
        <div class="text-wrapper-30" v-anim="'animate__fadeInDown'">关于云帆</div>
        <img class="mask-group-2" alt="Mask group" src="/static/img/about-mask-group.png" />
        <img class="rectangle-15" alt="Rectangle" src="/static/img/about-rectangle-148372.svg" />
        <img class="rectangle-16" alt="Rectangle" src="/static/img/about-rectangle-148394.svg" />
        <div class="rectangle-17" />
        <GroupSubsection1 />
        <div class="group-19" v-anim>
          <div class="text-wrapper-33">About .</div>
          <p class="heading-services-8">
            <span class="text-wrapper-34">关于云帆</span>
          </p>
          <img class="mask-group-4" alt="Mask group" src="/static/img/about-mask-group-3@2x.png" />
        </div>
      </div>
  
      <HeaderSubsection :fixed="true" />
      <div>
          <div class="rectangle-18" v-anim />
          <img class="vector-2" alt="Vector" src="/static/img/about-vector-456.svg" />
          <img class="vector-3" alt="Vector" src="/static/img/about-vector-456.svg" />
          <img class="vector-4" alt="Vector" src="/static/img/about-vector-456.svg" />
          <img class="vector-5" alt="Vector" src="/static/img/about-vector-459.svg" />
          <img class="vector-6" alt="Vector" src="/static/img/about-vector-459.svg" />
          <img class="vector-7" alt="Vector" src="/static/img/about-vector-459.svg" />
          <div class="heading-services-18" v-anim>云帆培优发展规划</div>
          <div class="heading-services-19">算法迭代</div>
          <div class="heading-services-20">
            重视教学且不断进化的组织基因；成体系、高势能且匹配的产品基因；聚焦高端与学习效果的品牌基因。
          </div>
          <div class="heading-services-21">
            开拓更多理科科目，拓展小学、初中、高中产品线，打造自主研发的教研产品；构建专业、负责任且不断创新的组织。
          </div>
          <div class="heading-services-22">
            顺应用户习惯的变化趋势，实现算法迭代；抓住社交媒体更新的机遇，构建学习平台，推出 1—3 款可覆盖更广泛学员的产品。
          </div>
          <p class="heading-services-23">
            <span class="text-wrapper-40"
              >学校目前正处在初创期，是大家加入的好时机，预计2025年的夏季班，学校长期班在读学员能够达到</span
            >
            <span class="text-wrapper-41">3</span>
            <span class="text-wrapper-42">千</span>
            <span class="text-wrapper-40"
              >人次，预计到2028年秋季，学校长期班在读学员能够达到</span
            >
            <span class="text-wrapper-43">7千</span>
            <span class="text-wrapper-40">人次！</span>
          </p>
          <div class="heading-services-24">提升势能</div>
          <div class="heading-services-25">树立基因</div>
          <div class="heading-services-26">从0-1000学员（1年）</div>
          <SectionComponentNodeSubsection1 />
          <div class="heading-services-27">从1千-3千学员（3年）</div>
          <div class="heading-services-28">从3千-7千学员（6年）</div>
          <div class="nested-proportional">
            <div class="ellipse-5" />
            <div class="ellipse-6" />
            <div class="ellipse-7" />
          </div>
      </div>
      <div>
        <img class="rectangle-19" alt="Rectangle" src="/static/img/about-rectangle-148392.svg" />
 
        <div class="group-20">
          <div class="text-wrapper-31">Remarkable achievements</div>
          <div class="text-wrapper-44">成绩斐然</div>
        </div>
        <div>
          <div class="heading-services-9" v-anim>中考成绩</div>
          <img class="rectangle-20" alt="Rectangle" src="/static/img/about-rectangle-148393@2x.png" v-anim style="animation-delay: 0.15s" />
            <p class="heading-services-10">
              <span class="text-wrapper-35">2018年至今，已有
              <span class="text-wrapper-36">5</span>
              位石家庄市中考状元师从云帆老师</span>
            </p>  
            <p class="heading-services-11" v-anim>
              <span class="text-wrapper-38">2018 年状元高天鸿——&nbsp;&nbsp;</span>
              <span class="name-gradient">杨鹏老师</span>
            </p>
            <p class="heading-services-12" v-anim>
              <span class="text-wrapper-38">2019 年市状元张栩越——&nbsp;&nbsp;</span>
              <span class="name-gradient">杨鹏老师</span>
            </p>
            <p class="heading-services-13" v-anim>
              <span class="text-wrapper-38"
                >2020 年市状元邱添&nbsp;&nbsp;——&nbsp;&nbsp;</span
              >
              <span class="name-gradient">李海刚老师</span>
            </p>
            <p class="heading-services-14" v-anim>
              <span class="text-wrapper-38">2023 年市状元任昶安——&nbsp;&nbsp;</span>
              <span class="name-gradient">李海刚老师</span>
            </p>
            <p class="heading-services-14b" v-anim>
              <span class="text-wrapper-38">2024 年市状元张文凯</span>
            </p>

        </div>
        <div>
          <div class="heading-services-15">二中自招</div>
          <img class="rectangle-21" alt="Rectangle" src="/static/img/about-rectangle-148395@2x.png" v-anim style="animation-delay: 0.3s" />
          <div class="admission-card-copy">
            <div>
              <strong>2024</strong>
              <p>二中自招 55 人<br />云帆学员 15 人</p>
            </div>
            <div>
              <strong>2025</strong>
              <p>二中自招 96 人<br />云帆学员 19 人</p>
            </div>
            <div>
              <strong>2026</strong>
              <p>二中自招 100 人<br />云帆学员 19 人</p>
            </div>
          </div>
        </div>

        <div>
          <div class="heading-services-16">高中联赛</div>
          <img class="rectangle-22" alt="Rectangle" src="/static/img/about-rectangle-148396@2x.png" v-anim style="animation-delay: 0.45s" />
          <div class="league-card-copy">
            <p><strong>2024</strong> 年省一 4 人：冯浩森、任昶安、石睿楷、韩旭渊。</p>
            <p><strong>2025</strong> 年省一 6 人、省二 16 人；另有 1 名学员获女子数学奥林匹克金牌。</p>
          </div>
          
        </div>
        
        <div>
          <div class="heading-services-17">小学成绩</div>
          <img class="rectangle-23" alt="Rectangle" src="/static/img/about-rectangle-148397@2x.png" v-anim style="animation-delay: 0.6s" />
          <p class="text-wrapper-37">
            多位学子获得 YMO、WMO 等杯赛的国赛金奖，所有教师均获得 YMO
            全国总决赛优秀指导教师。
          </p>
        </div>
      </div>
      <DivWrapperSubsection1 />
      <GroupWrapperSubsection1 />

      <div class="cultivation-and">Cultivation And Development Plan</div>
      <div class="rectangle-28" />
      <Group3Subsection :top="5661" />
    </div>
  </div>
</template>

<script>
import DivWrapperSubsection1 from "./sections/DivWrapperSubsection.vue";
import GroupSubsection1 from "./sections/GroupSubsection.vue";
import GroupWrapperSubsection1 from "./sections/GroupWrapperSubsection.vue";
import HeaderSubsection from "../Screen/sections/HeaderSubsection.vue";
import Group3Subsection from "../Screen/sections/Group3Subsection.vue";
import SectionComponentNodeSubsection1 from "./sections/SectionComponentNodeSubsection.vue";

export default {
  name: "AboutScreen",
  components: {
    DivWrapperSubsection1,
    GroupSubsection1,
    GroupWrapperSubsection1,
    HeaderSubsection,
    Group3Subsection,
    SectionComponentNodeSubsection1,
  },
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : 'animate__fadeInUp';
        el.classList.add('animate__animated');
        const io = new IntersectionObserver((entries)=>{
          entries.forEach(e=>{
            if (e.isIntersecting) {
              el.classList.add(cls);
              io.unobserve(el);
            }
          });
        }, { threshold: 0.2 });
        io.observe(el);
      }
    }
  },
  data() {
    return {
      baseWidth: 1920,
      baseHeight: 5894,
      targetWidth: 1920,
      targetHeight: 5894,
      viewportWidth: 0,
      viewportHeight:0
    };
  },
  computed: {
    scale1() {
      const w = this.viewportHeight || this.targetHeight;
      const clamped = Math.min(w, this.baseHeight);
      return  this.baseHeight/clamped ;
    },
    scale() {
      const w = this.viewportWidth || this.targetWidth;
      const clamped = Math.min(w, this.baseWidth);
      return clamped /this.baseWidth ;
    },
    screenStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: "top center",
        width: this.baseWidth + "px",
        position: "relative",
      // background:'#ffffff',
        minHeight: this.baseHeight + "px",
        
      };
    },
    screenWrapperStyle() {
      return {
        width: "100%",
        height: this.baseHeight * this.scale + "px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",

     //  overflowX: "hidden",
      };
    },
  },
  mounted() {
    this.viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    },
  },
};
</script>

<style scoped>

.screen {

  min-width: 1920px;
  
  position: relative;
  width: 100%;
}
.screen .mask-group-2 {
  height: 1118px;
  left: 0;
  position: absolute;
  top: 620px;
  width: 1920px;
}
.screen .mask-group-3 {
  height: 620px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1920px;
}
.screen .rectangle-15 {
  height: 158px;
  position: absolute;
  right: 1035px;
  top: 848px;
  width: 230px;
}
.screen .rectangle-16 {
  height: 154px;
  position: absolute;
  right: 166px;
  top: 1475px;
  width: 222px;
}
.screen .rectangle-17 {
  background-color: #edeff399;
  height: 740px;
  position: absolute;
  right: 180px;
  top: 878px;
  width: 1055px;
}
.screen .text-wrapper-30 {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 36px;
  font-weight: 500;
  left: 885px;
  letter-spacing: 1.8px;
  line-height: 54px;
  position: absolute;
  top: 283px;
  white-space: nowrap;
}
.screen .text-wrapper-31 {
  align-items: center;
  color: #00000017;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 40px;
  justify-content: center;
  left: 3px;
  letter-spacing: 0;
  line-height: 40px;
  position: absolute;
  top: 33px;
  white-space: nowrap;
}
.screen .group-19 {
  display: flex;
  flex-direction: column;
  height: 878px;
  left: 180px;
  position: absolute;
  top: 740px;
  width: 317px;
}
.screen .text-wrapper-33 {
  color: #00183c;
  font-family: "Poppins", Helvetica;
  font-size: 72px;
  font-weight: 600;
  height: 36px;
  letter-spacing: 0;
  line-height: 36px;
  white-space: nowrap;
  width: 258px;
}
.screen .heading-services-8 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 32px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: 32px;
  white-space: nowrap;
  width: 139px;
}
.screen .text-wrapper-34 {
  color: #00183c;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 32px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 30px;
}
.screen .mask-group-4 {
  height: 740px;
  margin-top: 40px;
  width: 313px;
}
.screen .rectangle-18 {
  background-color: #f6f7fa;
  height: 1123px;
  position: absolute;
  right: 0;
  top: 1751px;
  width: 1920px;
}
.screen .vector-2,
.screen .vector-3,
.screen .vector-4 {
  height: 6px;
  left: 1041px;
  object-fit: cover;
  position: absolute;
  width: 272px;
}
.screen .vector-2 {
  top: 2581px;
}
.screen .vector-3 {
  top: 2411px;
}
.screen .vector-4 {
  top: 2236px;
}
.screen .vector-5,
.screen .vector-6,
.screen .vector-7 {
  height: 6px;
  left: 528px;
  object-fit: cover;
  position: absolute;
  width: 354px;
}
.screen .vector-5 {
  top: 2581px;
}
.screen .vector-6 {
  top: 2411px;
}
.screen .vector-7 {
  top: 2236px;
}
.screen .rectangle-19 {
  height: 964px;
  position: absolute;
  right: 0;
  top: 2873px;
  width: 1920px;
}
.screen .heading-services-9 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 186px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 3176px;
  white-space: nowrap;
}
.screen .rectangle-20 {
  height: 450px;
  left: 180px;
  object-fit: cover;
  position: absolute;
  top: 3236px;
  width: 360px;
}
.screen .rectangle-21 {
  height: 450px;
  left: 580px;
  object-fit: cover;
  position: absolute;
  top: 3236px;
  width: 360px;
}
.screen .rectangle-22 {
  height: 450px;
  left: 980px;
  object-fit: cover;
  position: absolute;
  top: 3236px;
  width: 360px;
}
.screen .element-3 {
  align-items: center;
  color: transparent;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  height: 240px;
  justify-content: center;
  left: 1017px;
  letter-spacing: 0;
  line-height: 48px;
  position: absolute;
  top: 3279px;
  width: 286px;
}
.screen .text-wrapper-35 {
  color: #ffffff;
}
.screen .text-wrapper-36 {
  color: #0695e0;
  font-size: 32px;
}
.screen .rectangle-23 {
  height: 450px;
  left: 1380px;
  object-fit: cover;
  position: absolute;
  top: 3236px;
  width: 360px;
}
.screen .text-wrapper-37 {
  align-items: center;
  color: #ffffff;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  height: 192px;
  justify-content: center;
  left: 1416px;
  letter-spacing: 0;
  line-height: 48px;
  position: absolute;
  top: 3279px;
  width: 287px;
}
.screen .heading-services-10 {
  align-items: center;
  color: transparent;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 24px;
  font-weight: 500;
  height: 99px;
  justify-content: center;
  left: 209px;
  letter-spacing: 0;
  line-height: 48px;
  position: absolute;
  top: 3267px;
  width: 293px;
}
.screen .rectangle-24 {
  height: 34px;
  left: 424px;
  position: absolute;
  top: 3403px;
  width: 95px;
}
.screen .rectangle-25 {
  height: 34px;
  left: 424px;
  position: absolute;
  top: 3460px;
  width: 95px;
}
.screen .rectangle-26 {
  height: 34px;
  left: 424px;
  position: absolute;
  top: 3520px;
  width: 85px;
}
.screen .rectangle-27 {
  height: 34px;
  left: 424px;
  position: absolute;
  top: 3580px;
  width: 102px;
}
.screen .heading-services-11,
.screen .heading-services-12,
.screen .heading-services-13,
.screen .heading-services-14,
.screen .heading-services-14b {
  align-items: center;
  color: #ffffff;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  height: 32px;
  justify-content: center;
  left: 209px;
  letter-spacing: 0;
  line-height: 32px;
  position: absolute;
  white-space: nowrap;
}
.screen .heading-services-11 {
  top: 3405px;
}
.screen .heading-services-12 {
  top: 3462px;
}
.screen .heading-services-13 {
  top: 3522px;
}
.screen .heading-services-14 {
  top: 3582px;
}
.screen .heading-services-14b {
  top: 3638px;
}
.screen .heading-services-15 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 580px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 3176px;
  white-space: nowrap;
}
.screen .heading-services-16 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 980px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 3176px;
  white-space: nowrap;
}
.screen .heading-services-17 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 1380px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 3176px;
  white-space: nowrap;
}
.screen .nested-proportional {
  background-color: #0695e00d;
  border-radius: 300px;
  height: 600px;
  left: 660px;
  position: absolute;
  top: 2057px;
  width: 600px;
}
.screen .ellipse-5 {
  background-color: #0695e066;
  border-radius: 251.79px;
  height: 504px;
  left: 48px;
  position: absolute;
  top: 96px;
  width: 504px;
}
.screen .ellipse-6 {
  background-color: #0695e099;
  border-radius: 182px;
  height: 364px;
  left: 118px;
  position: absolute;
  top: 236px;
  width: 364px;
}
.screen .ellipse-7 {
  background-color: #0695e0;
  border-radius: 85.71px;
  height: 171px;
  left: 214px;
  position: absolute;
  top: 429px;
  width: 171px;
}
.screen .heading-services-18 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 180px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 1891px;
  white-space: nowrap;
}
.screen .heading-services-19 {
  align-items: center;
  color: #f6f7fa;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 896px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2220px;
  white-space: nowrap;
}
.screen .heading-services-20 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 64px;
  justify-content: center;
  left: 1322px;
  letter-spacing: 0;
  line-height: 32px;
  position: absolute;
  top: 2560px;
  width: 444px;
}
.screen .heading-services-21 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 64px;
  justify-content: center;
  left: 1322px;
  letter-spacing: 0;
  line-height: 32px;
  position: absolute;
  top: 2393px;
  width: 444px;
}
.screen .heading-services-22 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  height: 64px;
  justify-content: center;
  left: 1322px;
  letter-spacing: 0;
  line-height: 32px;
  position: absolute;
  top: 2222px;
  width: 451px;
}
.screen .heading-services-23 {
  align-items: center;
  color: transparent;
  display: flex;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  height: 32px;
  justify-content: center;
  left: 180px;
  letter-spacing: 0;
  line-height: 32px;
  position: absolute;
  top: 1985px;
  width: 1505px;
}
.screen .text-wrapper-40 {
  color: #00183c;
}
.screen .text-wrapper-41 {
  color: #3dabe6;
  font-size: 24px;
}
.screen .text-wrapper-42 {
  color: #3dabe6;
}
.screen .text-wrapper-43 {
  color: #0695e0;
}
.screen .heading-services-24 {
  align-items: center;
  color: #f6f7fa;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 896px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2394px;
  white-space: nowrap;
}
.screen .heading-services-25 {
  align-items: center;
  color: #f6f7fa;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 896px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2556px;
  white-space: nowrap;
}
.screen .heading-services-26 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 197px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2560px;
  white-space: nowrap;
}
.screen .heading-services-27 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 185px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2399px;
  white-space: nowrap;
}
.screen .heading-services-28 {
  align-items: center;
  color: #00183c;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 32px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  left: 180px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 2222px;
  white-space: nowrap;
}
.screen .group-20 {
  height: 73px;
  left: 186px;
  position: absolute;
  top: 2989px;
  width: 609px;
}
.screen .text-wrapper-44 {
  align-items: center;
  color: #1c4b8a;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 40px;
  justify-content: center;
  left: calc(50% - 304px);
  letter-spacing: 0;
  line-height: 40px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}
.screen .admission-card-copy {
  display: grid;
  gap: 10px;
  left: 616px;
  position: absolute;
  top: 3280px;
  width: 288px;
}
.screen .admission-card-copy > div {
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border-left: 3px solid #0695e0;
  border-radius: 0 4px 4px 0;
  display: grid;
  grid-template-columns: 68px 1fr;
  min-height: 94px;
  padding: 8px 10px;
}
.screen .admission-card-copy strong,
.screen .league-card-copy strong {
  color: #35b6f5;
  font-family: "Poppins", Helvetica;
  font-size: 20px;
  font-weight: 600;
}
.screen .admission-card-copy p {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  line-height: 26px;
  margin: 0;
}
.screen .league-card-copy {
  color: #ffffff;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 18px;
  left: 1017px;
  line-height: 34px;
  position: absolute;
  top: 3282px;
  width: 286px;
}
.screen .league-card-copy p {
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  margin: 0;
  padding: 0 0 18px;
}
.screen .league-card-copy p + p {
  border-bottom: 0;
  margin-top: 18px;
  padding-bottom: 0;
}
.screen .cultivation-and {
  align-items: center;
  color: #00000014;
  display: flex;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 48px;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  left: 180px;
  letter-spacing: 0;
  line-height: 30px;
  position: absolute;
  top: 1925px;
  white-space: nowrap;
}
.screen .rectangle-28 {
  background-color: #0695e0;
  height: 3px;
  left: 330px;
  position: absolute;
  top: 3359px;
  width: 142px;
}

.name-gradient {
  display: inline-block;
  padding: 0 8px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(58,160,255,0.6) 0%, rgba(58,160,255,0) 100%);
}
.screen-wrapper { width: 100%; position: relative; overflow: visible; }
</style>
